/**
 * Editorial sports light surface — warm paper, ink type, single pine accent.
 * Prefer hairline borders over shadows; avoid neon greens / cyan glow.
 */
export const HUB_PAGE_BG =
  "linear-gradient(180deg, #f6f5f2 0%, #fafaf8 38%, #ffffff 100%)";

/** Shared Tailwind-friendly class tokens for hub pages */
export const hub = {
  page: "bg-[#fafaf8] text-[#1a1c1e]",
  ink: "text-[#1a1c1e]",
  mute: "text-[#5c6370]",
  faint: "text-[#8b919c]",
  accent: "text-[#1b4d3e]",
  accentBg: "bg-[#1b4d3e]",
  accentSoft: "bg-[#e8f0ec]",
  border: "border-[#e6e4df]",
  surface: "bg-white border border-[#e6e4df]",
  surfaceHover: "hover:border-[#c9c6bf] hover:bg-[#fbfbfa]",
  btnPrimary:
    "inline-flex items-center justify-center rounded-lg bg-[#1b4d3e] px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#163f33]",
  btnGhost:
    "inline-flex items-center justify-center rounded-lg border border-[#e6e4df] bg-white px-4 py-2.5 text-sm font-semibold text-[#1a1c1e] transition-colors hover:border-[#c9c6bf] hover:bg-[#f6f5f2]",
  /** Equal-weight CTA for hub hero — no filled state (avoids looking "selected") */
  btnCta:
    "inline-flex items-center justify-center rounded-xl border border-[#d9d6cf] bg-white px-5 py-2.5 text-sm font-semibold text-[#1a1c1e] shadow-[0_1px_0_rgba(26,28,30,0.04)] transition-colors hover:border-[#1b4d3e]/40 hover:bg-[#f6f5f2] hover:text-[#1b4d3e] active:bg-[#f0efeb]",
  chip:
    "rounded-lg border border-[#e6e4df] bg-white text-[#3d4450] hover:border-[#c9c6bf] hover:bg-[#f6f5f2]",
  chipActive: "rounded-lg border border-[#1b4d3e] bg-[#1b4d3e] text-white",
} as const;
